import { FC } from 'react';
import dayjs from 'dayjs';
import Logo from '../assets/BIG_LOGO.webp';
import styles from './styles.module.less';


const ChristmasLogo: FC<{ onClick?: () => void }> = ({ onClick }) => {
  const targetTime = '2024-12-26 00:00:00';

  if (dayjs().isAfter(dayjs(targetTime))) {
    return (
      <div onClick={onClick} className={styles.logo}  style={{ height: window?.privateConfig?.logo_height || '0.46rem' }}>
        <img loading="lazy" src={(window?.imgPrefix || '') + (window.privateConfig?.logo || '/img/BIG_LOGO.webp')} alt="logo" />
      </div>
    );
  }
  return (
    <div onClick={onClick} className={styles.christmas_logo}>
      <img loading="lazy" src={window.privateConfig?.logo_christmas || `/img/christmas/BIG_LOGO.webp`} alt="logo" />
    </div>
  );
};

export default ChristmasLogo;
